import { useLazyQuery, useQuery } from '@apollo/client';

import ME_QUERY from 'graphql/user/queries/me.graphql';

import { MeQuery } from 'graphql/types';

export const useCurrentUser = (skip: boolean = false) =>
  // выставил флаг в true для случаев повторного запроса, когда данные не изменились
  // https://www.apollographql.com/docs/react/data/queries/#refetching
  // починил связанный с этим баг в withAuth
  // https://znanierussia.atlassian.net/browse/RU-470
  useQuery<MeQuery>(ME_QUERY, {
    skip,
    notifyOnNetworkStatusChange: true,
  });

export const useLazyCurrentUser = () => useLazyQuery<MeQuery>(ME_QUERY);
